import { render, staticRenderFns } from "./form-current-email-otp-confirm.vue?vue&type=template&id=28d205c3&scoped=true&lang=pug"
import script from "./form-current-email-otp-confirm.vue?vue&type=script&lang=js"
export * from "./form-current-email-otp-confirm.vue?vue&type=script&lang=js"
import style0 from "./form-current-email-otp-confirm.vue?vue&type=style&index=0&id=28d205c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d205c3",
  null
  
)

export default component.exports